import cn from 'classnames';
import React, { HTMLAttributes, ReactNode } from 'react';

import { type MaxPageWidthClasses, useMaxPageWidthStyles } from './MaxPageWidth.styles';

export type { MaxPageWidthClasses } from './MaxPageWidth.styles';

export type MaxPageWidthProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  classes?: MaxPageWidthClasses;
};

export const MaxPageWidth: React.FC<MaxPageWidthProps> = ({ children, classes: classOverrides, ...divProps }) => {
  const classes = useMaxPageWidthStyles();

  return (
    <div className={cn(classes.root, classOverrides?.root)} {...divProps}>
      <div className={cn(classes.centered, classOverrides?.centered)}>{children}</div>
    </div>
  );
};
